var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3085_175056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49654 4.04484C9.47839 4.04484 10.2743 3.2489 10.2743 2.26705C10.2743 1.2852 9.47839 0.489258 8.49654 0.489258C7.51469 0.489258 6.71875 1.2852 6.71875 2.26705C6.71875 3.2489 7.51469 4.04484 8.49654 4.04484Z",
    fill: "#9FA4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49654 10.2636C9.47839 10.2636 10.2743 9.46765 10.2743 8.4858C10.2743 7.50395 9.47839 6.70801 8.49654 6.70801C7.51469 6.70801 6.71875 7.50395 6.71875 8.4858C6.71875 9.46765 7.51469 10.2636 8.49654 10.2636Z",
    fill: "#9FA4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49654 16.4902C9.47839 16.4902 10.2743 15.6942 10.2743 14.7124C10.2743 13.7305 9.47839 12.9346 8.49654 12.9346C7.51469 12.9346 6.71875 13.7305 6.71875 14.7124C6.71875 15.6942 7.51469 16.4902 8.49654 16.4902Z",
    fill: "#9FA4A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3085_175056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.489258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreInfo);
export default __webpack_public_path__ + "static/media/moreInfo.5f61486dc657d19ed37bd6755e71ca7b.svg";
export { ForwardRef as ReactComponent };